module.exports = __webpack_public_path__ + "img/logo.c1c71396.png";